import { render, staticRenderFns } from "./EditBudgetType.vue?vue&type=template&id=578f8c32&scoped=true"
import script from "./EditBudgetType.vue?vue&type=script&lang=js"
export * from "./EditBudgetType.vue?vue&type=script&lang=js"
import style0 from "./EditBudgetType.vue?vue&type=style&index=0&id=578f8c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f8c32",
  null
  
)

export default component.exports